<ng-template #voucherModal let-modal>
  <div class="p-0 modal-body">
    <div class="voucher" [style]="appLoader ? 'min-height: 8rem;' : ''">
      <app-voucher [applicableVouchers]="vouchers" [isCheckout]="true" (applyVoucher)="applyVoucher($event)" (getApplicableVouchers)="getApplicableVouchers($event)"></app-voucher>
    </div>
  </div>
</ng-template>